var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 368",
    d: "M8.05556 12.1538H6C5.44772 12.1538 5 12.6015 5 13.1538V25C5 25.5523 5.44772 26 6 26H21.9259C22.4782 26 22.9259 25.5523 22.9259 25L22.9259 22.1538",
    stroke: "#CCCCD1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M20.6857 9.46312C12.8796 9.5846 10.2643 16.6987 9.9271 20.1986C9.90806 20.3963 10.1592 20.4819 10.2808 20.3248C12.9296 16.9029 18.1906 14.2563 20.711 14.3714C20.8133 14.3761 20.8889 14.4624 20.8889 14.5648V18.3212C20.8889 18.505 21.1159 18.5915 21.2382 18.4543L26.8825 12.1221C26.9497 12.0468 26.9502 11.9333 26.8838 11.8574L21.2395 5.40101C21.1179 5.26194 20.8889 5.34793 20.8889 5.53264V9.26154C20.8889 9.372 20.7961 9.4614 20.6857 9.46312Z",
    stroke: "#CCCCD1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchIcon);
export default __webpack_public_path__ + "static/media/launch-icon.35f275507b5fbe04c3fe131a2a5ce036.svg";
export { ForwardRef as ReactComponent };